import React, { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import MosaicPlaceholder from "../components/MosaicPlaceholder";
import theme from "../styles/theme";

const MainPage: React.FC = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  
  return (
    <Container maxWidth="lg" style={{ minHeight: "800px", minWidth: isMobile ? "unset" : "1250px" }}>
      <MosaicPlaceholder />
      <Box sx={{ textAlign: "left", mb: 4 }}>
        <Typography variant="body1" paragraph fontSize={"18px"} marginBottom={"-16px"}>
          Created in 2013, Operation RAILSAFE is a series of courses which focus on coordination with Amtrak’s partners (first responders, host railroads, transit agencies) to improve the security of passengers, employees, and infrastructure from acts of terrorism by enhancing the protection of soft targets/crowded places.
        </Typography>
      </Box>
      {isMobile ? 
        <Box sx={{ textAlign: "center", mt: 1, mb: 2 }}>
          <RouterLink to="/courses" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              style={{backgroundColor: "#00537E"}}
              size="large"
              sx={{
                px: 4,
                py: 1,
                fontSize: "1.1rem",
              }}
            >
              View course descriptions
            </Button>
          </RouterLink>
        </Box> : null}
      <Box sx={{ mb: 4 }}>
        <Typography color="#00537E" variant="h6">
          Operation RAILSAFE Partner Training
        </Typography>
        <ul style={{ marginTop: "0px"}}>
          {[
            "Strengthens coordination and integration between APD partner agencies by enhancing response, information sharing, and collaboration capabilities",
            "Provides participating agencies with situational awareness and a better understanding of how to protect Amtrak's passengers, employees, and critical infrastructure from acts of terrorism",
            "Decreases Amtrak's risk from and vulnerability to a potential attack by establishing interoperability, sharing resources, providing an overview of rail safety, and promoting partnership opportunities with like agencies",
            "Aids anti-terrorism efforts designed to protect the Amtrak employees, passengers, trains, and infrastructure and maximizes resource planning and allocation, as well as establishes and maintains critical relationships with partner agencies",
          ].map((item, index) => (
            <li key={index} >
              <ListItemText primaryTypographyProps={{fontSize: '18px'}}  primary={item} />
            </li>
          ))}
        </ul>
      </Box>
      {!isMobile ? 
        <Box sx={{ textAlign: "center", mt: 4, mb: 4 }}>
          <RouterLink to="/courses" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              style={{backgroundColor: "#00537E"}}
              size="large"
              sx={{
                px: 4,
                py: 1,
                fontSize: "16px",
              }}
            >
              Click Here to View Courses
            </Button>
          </RouterLink>
        </Box> : null}
    </Container>
  );
};

export default MainPage;
